import React from 'react';
import { Link } from 'react-router-dom';
import { productPath } from '../../utils/routes';

const ProductCard = ({ product }) => (
  <Link
    to={productPath(product)}
    className="product-tile"
  >
    <div className="product-tile-img">
      <img
        src={product.image}
        alt={`${product.name} ${product.category} manufacturer Aavjo Industries`}
        loading="lazy"
      />
    </div>
    <div className="product-tile-name">
      <span className="product-tile-model">{product.name}</span>
      {product.category && (
        <span className="product-tile-category">{product.category}</span>
      )}
    </div>
  </Link>
);

export default ProductCard;
